import { CdnImg } from '@/features/cdn-img';
import { Button } from '@nf/ui';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useSiteStore } from '@/store/site';
import { KafkaNote } from '@nf/utils-common/constants';
import { ViewEnum } from '@/types';
import { useAppearanceStore } from '@/store/appearance';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';


interface BetBuilderPlusSliderProps {
	onClose: () => void;
}

export const BetBuilderPlusSlider = ({ onClose }: BetBuilderPlusSliderProps) => {
	const router = useRouter();
	const t = useTranslations('General');
	const view = useAppearanceStore(state => state.view);

	const [
		activeFilterBetBuilderPlus
	] = useSiteStore(state => [
		state.activeFilterBetBuilderPlus
	]);

	const handleClickButton = () => {
		setKafkaNormal({
			note: KafkaNote.BetBuilderPlus,
			type: view == ViewEnum.mars ? 1 : 2,
			action: 2
		});
		router.push('/sports/2/l');
		activeFilterBetBuilderPlus();
		onClose();
	}

	return (
		<div className="bet-builder-plus-slider">
			<CdnImg
				src="/images/promotion-activity-modal/bet-builder-plus-slider/bg.png"
				alt=""
				width="480"
				height="360"
				className="bet-builder-plus-slider__img"
				isGalaxyFolder={true}
			/>
			<CdnImg
				src="/images/promotion-activity-modal/bet-builder-plus-slider/main.png"
				alt=""
				width={288}
				height={360}
				className="bet-builder-plus-slider__img"
				isGalaxyFolder={true}
			/>
			<div className="bet-builder-plus-slider__content">
				<div className="bet-builder-plus-slider__title">
					<div className="bet-builder-plus-slider__title-main">{t('lbl_betbuilderplus')}</div>
					<div className="bet-builder-plus-slider__title-shadow">{t('lbl_betbuilderplus')}</div>
				</div>
				<div className="bet-builder-plus-slider__text">
					<div className="bet-builder-plus-slider__text-item">{t('lbl_BBPopup01')}</div>
					<div className="bet-builder-plus-slider__text-item">{t('lbl_BBPopup02')}</div>
					<div className="bet-builder-plus-slider__text-item">{t('lbl_BBPopup03')}</div>
				</div>
			</div>
			<div className="bet-builder-plus-slider__btn">
				<Button
					variant="classic"
					onClick={handleClickButton}
				>
					{t('lbl_BBPopup04')}
				</Button>
			</div>
		</div>
	)
}